import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AddressesService} from "../../services/addresses-service.factory";
import {Address} from "../../models/address.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {PlanningDraftsService} from "../../../planning/services/planning-drafts-service.service";
import {AddressRequestType} from "../../angular/types/address-request.type";

export class AddressesResolverEditViewCtrl implements IController {

  addressId: string;
  query: any;
  type: any;
  close: Function

  public address: any;
  public showEditResults: boolean;
  public currentSection: 's1' | 's2' | 's3';
  public isManualChosen: boolean;
  public fullAddress: string;
  public isMapByFieldSelected: boolean;
  public recommendedAddressFormatted: any;
  public validatedAddress: any;

  public exactAddressResolution: boolean = false;
  public servicesList: any[];
  public ordersList: any[];
  public recommendedAddress: any;
  public missingFields: any[];

  private autocompleteService: any;
  private geocoder: any;
  private missingAddressValue: boolean;
  public cityChecked: boolean;
  public streetChecked: boolean;
  public isUseGoogleValidation: boolean;
  public updateServices: boolean = false;
  public updateAccounts: boolean = false;

  /* @ngInject */
  constructor(private addressesService: AddressesService,
              private planningDraftsService: PlanningDraftsService,
              private splitService: SplitService,
              private $filter,
              private $log,
              private $q) {
    this.autocompleteService = new google.maps.places.AutocompleteService();
    this.geocoder = new google.maps.Geocoder;
    this.isUseGoogleValidation = this.splitService.getSiteUseGoogleAddressValidation();
  }

  $onInit() {
    this.address = undefined;
    this.addressesService.getAddressByAddressId(this.addressId)
        .then((address) => {
          this.address = this._setValidatedAddress(address);

          if(!this.isUseGoogleValidation){
            this.currentSection = 's2';
            this.onAddressEditingDone();
          }else{
            this.currentSection = 's1';
            this._getRecommendedAddress(this.address.validatedAddress);
          }

        })
        .catch((error) => {
          this.onCancelEdit();
        })

    this.isManualChosen = true;
    this.isMapByFieldSelected = true;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.addressId && !changes.addressId.isFirstChange()){
      this.$onInit();
    }
  }

  onBackToEditing() {
    this.showEditResults = false;
    this.cityChecked = undefined;
    this.streetChecked = undefined;
    if(this.missingAddressValue || !this.isUseGoogleValidation) {
      this.currentSection = 's2';
    }else{
      this.currentSection = 's1';
    }
  }

  onManualChange() {
    if (this.isManualChosen) {
      this._setMissingFields(this.address.validatedAddress);
    } else {
      this._setMissingFields(this.validatedAddress);
    }
  }

  onValidatedAddressChange(address) {
    this.validatedAddress = address;
  }

  onAddressEditingDone() {
    this.missingAddressValue = false;
    // this._setMissingFields(this.address.validatedAddress);

    if(this.isManualChosen) {
      this.validatedAddress = angular.copy(this.address.validatedAddress);
      this.currentSection = 's2';
    }

    if(!this.isManualChosen) {
      this.validatedAddress = angular.copy(this.recommendedAddressFormatted);
      this._setMissingFields(this.validatedAddress);
      if (this.missingAddressValue) {
        this.currentSection = 's2';
      }else{
        this.currentSection = 's3';
        this.showEditResults = true;
      }
    }
  }

  // go to third screen if the first radio option is chosen:
  onAddressValidationDone() {
    this.currentSection = 's3';
    this.showEditResults = true;
  }

  onToggleExactAddressResolution(exactAddressResolution: boolean) {
    this.exactAddressResolution = exactAddressResolution;
  }

  onToggleChangeResolvingMod(){
    this.isMapByFieldSelected = !this.isMapByFieldSelected;
  }

  onUpdateServiceAndAccountsToggle(){
    this.updateServices = !this.updateServices;
    this.updateAccounts = !this.updateAccounts;
  }

  onSaveAddress() {
    if (this.streetChecked) {
      this.address.exactAddressResolution = false;
    }else{
      this.address.exactAddressResolution = true;
    }

    const addressCopy = angular.copy(this.address);
    addressCopy.resolved = true;
    addressCopy.validatedAddress = angular.copy(this.validatedAddress);
    if(this.type == AddressRequestType.Planning) {
      this.planningDraftsService.updateAddress(this.query.projectId, this.query.draftId,
        this.addressId, addressCopy, this.updateServices, this.updateAccounts,).finally(() => {
        this.onCancelEdit();
      });
    } else {
      this.addressesService.updateAddress(addressCopy, this.streetChecked, this.cityChecked,
        this.updateServices, this.updateAccounts)
      .finally(() => {
        this.onCancelEdit();
      });
    }
  }

  onCityCheckChange(cityChecked) {
    this.cityChecked = cityChecked;
  }

  onStreetCheckChange(streetChecked) {
    this.streetChecked = streetChecked;
  }

  onRefreshMap(){
    this._getPlacePredictions(this.$filter('bringozAddress')(this.validatedAddress))
        .then((predictions) => {
          const selectedPrediction = predictions[0];

          if (!selectedPrediction.place_id) {
            // Do something
          } else {
            this._geocode(selectedPrediction.place_id)
                .then((predication) => {
                  const location = {
                    lat: predication.geometry.location.lat(),
                    latitude: predication.geometry.location.lat(),
                    lng: predication.geometry.location.lng(),
                    longitude: predication.geometry.location.lng()
                  };
                  const validatedAddress = angular.copy(this.validatedAddress);
                  validatedAddress.location = location;
                  this.validatedAddress = validatedAddress
                })
          }
        })
  }

  private _setMissingFields(address) {
    const missingFields: any = {};

    if (!address.city) {
      missingFields.city = true;
      this.missingAddressValue = true; // true if some of the values will be missing
    }
    if (!address.state) {
      missingFields.state = true;
    }
    if (!address.country) {
      missingFields.country = true;
      this.missingAddressValue = true;
    }
    if (!address.house) {
      missingFields.house = true;
      this.missingAddressValue = true;
    }
    if (!address.street) {
      missingFields.street = true;
      this.missingAddressValue = true;
    }
    if (!address.zipCode) {
      missingFields.zipCode = true;
    }
    if (!address.floor) {
      missingFields.floor = true;
    }
    if (!address.apt) {
      missingFields.apt = true;
    }
    if (!address.entrance) {
      missingFields.entrance = true;
    }

    this.missingFields = missingFields;
  }


  //////////////////////////////////// Private Methods ////////////////////////////////////
  // this.$filter('bringozAddress')(validatedAddress)
  private _getRecommendedAddress(validatedAddress){
    const payload = {
      address: {
        regionCode: this.splitService.getCountryCode(), // for ikea: 'UK'
        addressLines: [
          this.$filter('bringozAddress')(validatedAddress),
        ]
      }
    }
    this.addressesService.getValidatedAddress(payload)
        .then((address) => {
          this.recommendedAddress = address;
          this.recommendedAddressFormatted = this._googlePlaceToAddress(address.result);

          this.recommendedAddressFormatted.floor = _.get(validatedAddress, 'floor');
          this.recommendedAddressFormatted.apt = _.get(validatedAddress, 'apt');
          this.recommendedAddressFormatted.entrance = _.get(validatedAddress, 'entrance');

          this._setMissingFields(this.recommendedAddressFormatted);
        })
        .catch((error) => {
          this.onCancelEdit();
        })
  }

  private _getPlacePredictions(input) {
    const deferred = this.$q.defer();

    this.autocompleteService.getPlacePredictions({
      input: input,
      types: ['geocode']
    },(predictions, status) => {

      if (status === google.maps.places.PlacesServiceStatus.OK) {
        deferred.resolve(predictions);
      }
      else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        deferred.resolve([]);
      }
      else{
        this.$log.error('getPlacePredictions fail', status);
        deferred.reject(status)
      }
    });

    return deferred.promise;
  }

  private _geocode(placeId) {
    const deferred = this.$q.defer();

    this.geocoder.geocode({ placeId: placeId}, (place, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        deferred.resolve(place[0]);
      } else {
        this.$log.error('geocode fail', status);
        deferred.reject(status)
      }
    });

    return deferred.promise;
  }

  private onCancelEdit() {
    this.servicesList = undefined;
    this.ordersList = undefined;
    this.close();
  }


  private _setValidatedAddress(address) {
    if (_.isUndefined(address.validatedAddress)) {
      _.set(address, 'validatedAddress.house', address.originalAddress.house);
      _.set(address, 'validatedAddress.street', address.originalAddress.street);
      _.set(address, 'validatedAddress.city', address.originalAddress.city);
      _.set(address, 'validatedAddress.state', address.originalAddress.state);
      _.set(address, 'validatedAddress.country', address.originalAddress.country);
      _.set(address, 'validatedAddress.zipCode', address.originalAddress.zipCode);

      _.set(address, "validatedAddress.location", angular.copy(address.originalAddress.location))
    }
    return address;
  }

  private _isOriginalAndValidatedEqual(originalAddress, validatedAddress): boolean {
    return originalAddress.house != validatedAddress.house ||
        originalAddress.street != validatedAddress.street ||
        originalAddress.city != validatedAddress.city ||
        originalAddress.state != validatedAddress.state ||
        originalAddress.country != validatedAddress.country ||

        originalAddress.location.longitude != validatedAddress.location.longitude ||
        originalAddress.location.latitude != validatedAddress.location.latitude ||
        originalAddress.location.lng != validatedAddress.location.lng ||
        originalAddress.location.lat != validatedAddress.location.lat
  }

  private getOrdersAndDeliveriesUsingAddress() {
    return this.addressesService.getOrdersAndDeliveriesUsingAddress(this.addressId)
        .then((res) => {
          this.servicesList = res.services;
          this.ordersList = res.orders;
        })
  }

  private _predicationToAddress(place): Address{

    if (place.address_components.length < 3) return {};

    function getTypeValue(type) {
      for (var i = 0; i < place.address_components.length; i++) {
        var component = place.address_components[i];
        for (var j = 0; j < component.types.length; j++) {
          var componentType = component.types[j];
          if (componentType === type) {
            return component.long_name;
          }
        }
      }
      return undefined;
    }

    return {
      house : getTypeValue('street_number'),
      neighborhood: getTypeValue('neighborhood'),
      street : getTypeValue('route') || getTypeValue('neighborhood'),
      city : getTypeValue('locality'),
      country : getTypeValue('country'),
      state : getTypeValue("administrative_area_level_1"),
      location : {
        longitude: place.geometry.location.lng(),
        latitude: place.geometry.location.lat()
      },
      place : place.formatted_address,
      placeId : place.place_id
    };
  }

  private _googlePlaceToAddress(result): Address{

    if (result.address.addressComponents.length < 3) return {};

    function getTypeValue(type) {
      for (var i = 0; i < result.address.addressComponents.length; i++) {
        var component = result.address.addressComponents[i];
        var componentType = component.componentType;
        if (componentType === type) {
          return component.componentName.text;
        }
      }
      return undefined;
    }

    return {
      house: getTypeValue('street_number'),
      neighborhood: getTypeValue('neighborhood') || getTypeValue('sublocality_level_1'),
      street: getTypeValue('route') || getTypeValue('neighborhood'),
      city: getTypeValue('postal_town') || getTypeValue('locality') || getTypeValue('sublocality_level_1') || getTypeValue('administrative_area_level_1'),
      country: getTypeValue('country'),
      state: getTypeValue("administrative_area_level_1"),
      zipCode: getTypeValue("postal_code"),
      location: {
        longitude: result.geocode.location.longitude,
        latitude: result.geocode.location.latitude
      },
      place: result.formattedAddress,
      placeId: result.geocode.placeId
    };
  }

  /*
  * house => street_number
  * neighborhood => neighborhood
  * street => route.text
  * city => locality || sublocality_level_1
  * country => country
  * state => administrative_area_level_1
  *
  * location {
  *   longitude
  *   latitude
  * }
  * ==>
  * geoCode {
  *   location {
  *     latitude
  *     longitude
*     }
  * }
  *
  * place => address.formattedAddress
  * placeId
  * */
}

angular
    .module('bringoz.admin.addresses')
    .component('addressesResolverEditView', {
      bindings: {
        addressId: '<',
        query: '<',
        type: '<',
        close: '&'
      },
      template: require('./addresses-resolver-edit-view.html').default,
      controller: AddressesResolverEditViewCtrl
    });
